var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-notification-list" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.notifications, function (notification, index) {
        return _c(
          "div",
          { key: index },
          [_c("NotificationItem", { attrs: { notification: notification } })],
          1
        )
      }),
      _vm._v(" "),
      _vm.seeAllUrl
        ? _c("div", { staticClass: "c-notification-list-link" }, [
            _c("a", { attrs: { href: _vm.seeAllUrl } }, [
              _vm._v(_vm._s(_vm.seeAllLabel)),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-notification-list-header" }, [
      _c("div", [_vm._v("Date")]),
      _vm._v(" "),
      _c("div", [_vm._v("Headline")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }